import { saveFirmDetailsActions } from "./action";

const initialState = {
  yourFirmDetails: null,
};

const saveFirmDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case saveFirmDetailsActions.SAVE_FIRM_DETAILS_SUCCESS:
      return {
        ...state,
        yourFirmDetails: action.payload,
      };
    case saveFirmDetailsActions.SAVE_FIRM_DETAILS_ERROR:
      return {
        ...state,
        yourFirmDetails: [],
      };
    default:
      return state;
  }
};

export default saveFirmDetailsReducer;
